import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useQueryString from '../../../../hooks/use-query-string';

export default function PastImagesBuilder() {
  // Routing and queries
  const { packageId } = useParams();
  const history = useHistory();
  const {
    step,
    opt: optionId,
    pastImages,
    favorites,
  } = useQueryString();

  return (
    <div>Builder Page</div>
  );
}
